import {
  ConfigurationView,
  ConfigurationApplicationView,
  ConfigurationCommunicationView,
  ConfigurationRequestsView,
} from '@/views';

const routes = {
  privatePaths: [
    {
      path: '/configuration',
      component: ConfigurationView,
      children: [
        {
          path: '',
          component: ConfigurationView,
          name: 'Configuration',
        },
      ],
    },
    {
      path: '/configuration/applications',
      component: ConfigurationApplicationView,
      name: 'ConfigurationApplications',
    },
    {
      path: '/configuration/requests',
      component: ConfigurationRequestsView,
      name: 'ConfigurationRequests',
    },
    {
      path: '/configuration/communication',
      component: ConfigurationCommunicationView,
      name: 'ConfigurationCommunication',
    },
  ],
  publicPaths: [],
};

export default routes;
